module.exports = __webpack_public_path__ + "img/sxm.522d898c.svg";